// extracted by mini-css-extract-plugin
export default {"info":"style_info__fueA-","eventTitle":"style_eventTitle__mvbW4","speakerContainer":"style_speakerContainer__VFmZ1"};